// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9bf28bb7","455":"0a067f9f","977":"a187faf2"}[chunkId] + ".chunk.js";
};